// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Cookies from 'js-cookie';

import '@/assets/stylus/global.styl';
import '@/assets/stylus/common.styl';

import iView from 'iview';
import { Cascader } from 'element-ui';
import 'iview/dist/styles/iview.css';

// GraphQL
import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import VueApollo from 'vue-apollo';
import { link } from '@/graphql/apply-ware.js';

Vue.use(Cascader);
/**
 * 添加实例属性， 封装提示信息
 * @param {String} message 提示文本
 */
Vue.prototype.$setNotice = function(message) {
    // iView.Notice.destroy();
    iView.Notice.open({
        title: message
    });
};

// Create the apollo client
const apolloClient = new ApolloClient({
    link: link,
    cache: new InMemoryCache(),
    connectToDevTools: true
});
const apolloProvider = new VueApollo({
    defaultClient: apolloClient
});

Vue.config.productionTip = false;

// Install the vue plugin
Vue.use(VueApollo);
Vue.use(iView);

let lastIndexContent = '';

// 初始获取index.html内容（用于后续对比）
fetch('/index.html')
    .then(res => res.text())
    .then(content => {
        lastIndexContent = content;
    });

router.afterEach(() => {
    fetch('/index.html')
        .then(res => res.text())
        .then(newContent => {
            if (newContent !== lastIndexContent) {
                if (confirm('检测到新版本，是否刷新页面？')) {
                    lastIndexContent = newContent;
                    window.location.reload(true);
                }
            }
        });
});

router.beforeEach((to, from, next) => {
    const token = Cookies.getJSON('token');
    const CliqueName = Cookies.getJSON('cliqueNo');
    if (to.meta.requireAuth) {
        if (token) {
            if (CliqueName) {
                next();
            } else {
                iView.Notice.open({
                    title: '请选取组织'
                });
                next({
                    path: '/'
                });
            }
        } else {
            iView.Notice.open({
                title: '请先登录'
            });
            next({
                path: '/'
            });
        }
    } else {
        next();
    }
});

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: {
        App
    },
    apolloProvider,
    template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js